import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { SALUTATIONS } from '../constants';
import { OnlinetestModel } from './onlinetest.model';
import { BusinessunitModel } from './businessunit.model';
import { ResourceModel } from './resource.model';
import { Validator } from '../helpers/validator';

export enum ReportModes {
  Candidate = 'candidate',
  Other = 'other',
  Both = 'both',
}

export class ToolboxCandidateModel extends BaseModel implements Deserializable {

  // columns
  language: string;
  status: string;

  gender: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  mobile: string;

  orderer_gender: string; // tslint:disable-line: variable-name
  orderer_firstname: string; // tslint:disable-line: variable-name
  orderer_lastname: string; // tslint:disable-line: variable-name
  orderer_email: string; // tslint:disable-line: variable-name
  orderer_phone: string; // tslint:disable-line: variable-name
  orderer_mobile: string; // tslint:disable-line: variable-name

  report_recipient_type: string; // tslint:disable-line: variable-name
  report_recipient_gender: string; // tslint:disable-line: variable-name
  report_recipient_firstname: string; // tslint:disable-line: variable-name
  report_recipient_lastname: string; // tslint:disable-line: variable-name
  report_recipient_email: string; // tslint:disable-line: variable-name

  login_url: string; // tslint:disable-line: variable-name
  login_user: string; // tslint:disable-line: variable-name
  login_password: string; // tslint:disable-line: variable-name
  login_informations: string; // tslint:disable-line: variable-name
  hashed_id: any; // tslint:disable-line: variable-name
  status_list: Array<string>; // tslint:disable-line: variable-name

  // relations
  businessunit: BusinessunitModel;
  onlinetest: OnlinetestModel;
  resources: Array<ResourceModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // businessunit
    if (this.businessunit !== null && this.businessunit !== undefined) {
      this.businessunit = new BusinessunitModel().deserialize(this.businessunit);
    }
    // onlinetest
    if (this.onlinetest !== null && this.onlinetest !== undefined) {
      this.onlinetest = new OnlinetestModel().deserialize(this.onlinetest);
    }
    // resources
    let resources = null;
    if (this.resources !== null && this.resources !== undefined) {
      resources = [];
      this.resources.forEach((resource: ResourceModel) => {
        resources.push(new ResourceModel().deserialize(resource));
      });
    }
    this.resources = resources;
    return this;
  }

  get fullname(): string {
    return (this.firstname || '') + ' ' + (this.lastname || '');
  }

  get fullname_reverse(): string {
    const parts = [];
    if (this.lastname) {
      parts.push(this.lastname);
    }
    if (this.firstname) {
      parts.push(this.firstname);
    }
    return parts.join(', ');
  }

  get partnername(): string {
    return (Validator.isObject(this.onlinetest.partner)) ? this.onlinetest.partner.name : '---';
  }

  get onlinetestname(): string {
    return (Validator.isObject(this.onlinetest)) ? this.onlinetest.fullname : '---';
  }

  get testname(): string {
    return (Validator.isObject(this.onlinetest)) ? this.onlinetest.name : '---';
  }

  get businessunitname(): string {
    return (Validator.isObject(this.businessunit)) ? this.businessunit.name : '---';
  }

  getSalutation(): string {
    return SALUTATIONS[this.gender];
  }

  isBeforeStatus(status): boolean {
    return this.status_list.indexOf(this.status) < this.status_list.indexOf(status);
  }

  get results_active(): boolean {
    return ['finished', 'result'].indexOf(this.status) !== -1;
  }

  get credentials_active(): boolean {
    return ['created'].indexOf(this.status) !== 0;
  }

  get basedata_editable(): boolean {
    return this.status === 'created' || this.status === 'confirmed' || this.status === 'credentials';
  }

  get credentials_editable(): boolean {
    return this.status === 'confirmed' || this.status === 'credentials';
  }

  get report_sended(): any {
    if (this.resources.length > 0) {
      const resource = this.resources[0];
      return (resource.misc?.report_sended) ? resource.misc.report_sended : resource.created_at;
    }
    return null;
  }

  get created_as_date(): Date {
    return new Date(this.created_at);
  }

  get translated_status_name(): string {
    return this.transloco?.translate('common.toolbox_status.' + this.status);
  }

}
